export const colorMap = {
    red: "redRedWine",
    white: "#dec8ad",
    rose: "#fdbebf",
    sparkling: "#dec8ad",
  };